import { render, staticRenderFns } from "./TickerList.vue?vue&type=template&id=0bd29c3c&scoped=true"
import script from "./TickerList.vue?vue&type=script&lang=js"
export * from "./TickerList.vue?vue&type=script&lang=js"
import style0 from "./TickerList.vue?vue&type=style&index=0&id=0bd29c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd29c3c",
  null
  
)

export default component.exports